var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2AddedProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.32 44.5L48.8 60.84l-7.32-8.54 3-2.6 4.68 5.46L64.68 41.5l2.64 3zM40 30V17a6 6 0 016-6h13a6 6 0 016 6v13a6 6 0 01-6 6H46a6 6 0 01-6-6zm4 0a2 2 0 002 2h13a2 2 0 002-2V17a2 2 0 00-2-2H46a2 2 0 00-2 2v13zm-8 16v13a6 6 0 01-6 6H17a6 6 0 01-6-6V46a6 6 0 016-6h13a6 6 0 016 6zm-4 0a2 2 0 00-2-2H17a2 2 0 00-2 2v13a2 2 0 002 2h13a2 2 0 002-2V46zm4-29v13a6 6 0 01-6 6H17a6 6 0 01-6-6V17a6 6 0 016-6h13a6 6 0 016 6zm-4 0a2 2 0 00-2-2H17a2 2 0 00-2 2v13a2 2 0 002 2h13a2 2 0 002-2V17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Added_product.f7b587db.svg";
export { SvgJ2AddedProduct as ReactComponent };